import React from "react";
import { Button, Card, Col, Divider, Row, Statistic, Tooltip } from "antd";
import { useEffort } from "hook/draft/effort/useEffort";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { ImWarning } from "react-icons/im";
import { useResponsive } from "hook/useResponsive";
import { RightOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DetailTracking = () => {
  // -------------------------- VAR -----------------------------
  const [_, setSearchParams] = useSearchParams();
  const { mobile } = useResponsive();
  const { effort, exp, ease, mistake, pass, warn, deny } = useEffort();
  const size = 20;

  const justifyContent = mobile ? "center" : "space-between";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleViewDetail = () => {
    setSearchParams({ viewOpenScore: true, page: 1, tab: "pass" });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLeft = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 40,
        }}
      >
        {renderPass()} {renderWarn()} {renderFail()}
      </div>
    );
  };

  const renderPass = () => {
    return (
      <Tooltip title={`Đoạn hội thoại đã được phê duyệt hợp lệ`}>
        <div>
          <span className="text-[14px] text-gray-500">Được duyệt</span>
          <div className="flex flex-row items-center gap-1">
            <IoMdCheckmarkCircleOutline size={size} color="green" />
            <div className="text-[16px] text-green-700">{pass}</div>
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderWarn = () => {
    return (
      <Tooltip title={`Đoạn hội thoại đã được cảnh báo chưa hợp lệ`}>
        <div>
          <span className="text-[14px] text-gray-500">Cảnh báo</span>
          <div className="flex flex-row items-center gap-1">
            <ImWarning size={size - 2} color="orange" />
            <div className="text-[16px] text-orange-700">{warn}</div>
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderFail = () => {
    return (
      <Tooltip title={`Đoạn hội thoại đã bị tự chồi vì không hợp lệ`}>
        <div>
          <span className="text-[14px] text-gray-500">Từ chối</span>
          <div className="flex flex-row items-center gap-1">
            <IoIosCloseCircleOutline size={size + 2} color="red" />
            <div className="text-[16px] text-red-700">{deny}</div>
          </div>
        </div>
      </Tooltip>
    );
  };

  const renderRight = () => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 40 }}>
        {renderExp()}
        {renderEffort()}
        {renderEase()}
        {renderMistake()}
      </div>
    );
  };

  const renderExp = () => {
    return (
      <Tooltip title={`Điểm kinh nghiệm`}>
        <Statistic
          title="Exp"
          value={exp}
          valueStyle={{
            fontSize: 16,
            textAlign: "center",
          }}
        />
      </Tooltip>
    );
  };

  const renderEffort = () => {
    return (
      <Tooltip title={`Điểm nỗ lực khi sửa câu`}>
        <Statistic
          title="Sửa"
          value={effort}
          valueStyle={{
            fontSize: 16,
            textAlign: "center",
          }}
        />
      </Tooltip>
    );
  };

  const renderEase = () => {
    return (
      <Tooltip title={`Điểm nỗ lực khi xoá câu`}>
        <Statistic
          title="Xoá"
          value={ease}
          valueStyle={{
            fontSize: 16,
            textAlign: "center",
          }}
        />
      </Tooltip>
    );
  };

  const renderMistake = () => {
    return (
      <Tooltip title={`Lỗi sai khi làm`}>
        <Statistic
          title="Sai"
          value={mistake}
          valueStyle={{
            fontSize: 16,
            textAlign: "center",
          }}
        />
      </Tooltip>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Card styles={{ body: { padding: 0 } }} style={{ marginBottom: 20 }}>
      <Row
        className="px-[24px] py-[16px]"
        gutter={[0, 20]}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent,
        }}
      >
        <Col>{renderLeft()}</Col>
        <Col>{renderRight()}</Col>
      </Row>
      <Divider style={{ margin: 0 }} />
      <div className="flex flex-row items-center justify-end px-[16px] py-[16px]">
        <Button
          onClick={handleViewDetail}
          icon={<RightOutlined />}
          className="underline"
          type="link"
        >
          Xem chi tiết
        </Button>
      </div>
    </Card>
  );
};
export default DetailTracking;
